export default __webpack_public_path__ + "static/media/37FCEC13-C102-4B4A-9FC3-35E02533DAEF_1_105_c.3b684fdb.jpeg";